import React from "react";
import { Grid, Paper, Typography, Stack, Box } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

function ResultsComponent({ results, inputData }) {
  if (!results || Object.keys(results).length === 0) {
    return <div>No results to display yet.</div>;
  }

  const activeResults = results.activeResults;
  const earthResults = results.Earth_Result
  

  // Extracting values
  const Active_cable_size = activeResults?.selectedCableSize;
  const Active_cable_mode = inputData?.activeCableSizingMode;
  const Circuit_capacity_derated = activeResults?.currentCarryingCapacity?.circuitRatingDerated;
  const Circuit_capacity = activeResults?.currentCarryingCapacity?.circuitRating;
  const spare_capacity = Math.round(activeResults?.currentCarryingCapacity?.spareCapacity * 100) / 100;
  const number_of_active_circuits = activeResults?.number_of_circuits;
  const current_carrying_cap_ok = activeResults?.currentCarryingCapacity?.ok;
  const current_carrying_cap_ref = activeResults?.currentCarryingCapacity?.current_capacity_ref;

  const Voltage_drop = Math.round(activeResults?.voltageDrop?.voltageDropCable * 100) / 100;
  const voltage_drop_percent = Math.round(activeResults?.voltageDrop?.voltageDropPercent * 100) / 100;
  const max_length_cable = Math.round(activeResults?.voltageDrop?.maxLengthOfCable * 100) / 100;
  const resistance_active = activeResults.voltageDrop?.resistancePerKm;
  const reactance_active = activeResults.voltageDrop?.reactancePerKm;
  const operating_temp_calculation = Math.round(activeResults?.voltageDrop?.operatingTempCalculated * 100) / 100;
  const voltage_drop_cap_ok = activeResults?.voltageDrop?.ok;
  const resistance_active_ref = activeResults.voltageDrop?.resistance_per_km_ref;
  const reactance_active_ref = activeResults.voltageDrop?.reactance_per_km_ref;

  const short_circuit_soure = activeResults?.shortCircuitCapacity?.faultLevelSupply;
  const short_circuit_load = Math.round(activeResults?.shortCircuitCapacity?.faultLevelLoad * 100) / 100;
  const K_value = activeResults?.shortCircuitCapacity?.KValue;
  const source_impedance = activeResults?.shortCircuitCapacity?.sourceImpedance;
  const total_impedance = activeResults?.shortCircuitCapacity?.totalImpedance;
  const short_circuit_capacity = Math.round(activeResults?.shortCircuitCapacity?.ICalculation * 100) / 100;
  const short_circuit_cap_ok = activeResults?.shortCircuitCapacity?.ok;
  const K_value_ref = activeResults?.shortCircuitCapacity?.KValue_ref;
  const derating = activeResults?.Derating


  const Earth_cable_size = earthResults?.Earth_cable_size;
  const number_of_earth_circuit = earthResults?.number_of_earth_circuits;
  const earthCableSizingMode = inputData?.earthCableSizingMode;
  const earthRef = earthResults?.ref
  const EFLcheck = earthResults?.Loop_impedance_check
  const ImpedanceEarth = earthResults?.Impednace_earth
  const ImpedanceActive = earthResults?.Impedance_active
  const Zint = Math.round(earthResults?.Z_int* 10000) / 10000;
  const Zext = Math.round(earthResults?.Z_ext* 10000) / 10000;
  const EFL = Math.round(earthResults?.Loop_impedance* 10000) / 10000;
  const earthfaultlevel =  inputData?.earthfaultlevel;
  const earthfaultlevelcheck =  earthResults?.short_circuit_ok;
  const earthshortcircuitcap = Math.round(earthResults?.short_circuit_cap* 100) / 100;
  const kvalue = earthResults?.K;
  const K_value_refearth = earthResults?.K_value_ref;
  const Requiredloopimpidance = Math.round(earthResults?.Requiredloopimpidance* 100) / 100;
  const earth_Fault_level = Math.round(earthResults?.earth_Fault_level* 100) / 100;


 

  return (
<div className="App">
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems=""
        style={{ minHeight: "10vh",
            padding: "1.5rem",
         }}
      >
       <Grid item xs={12} sm={12} md={12}>
          <Paper
            elevation={6}
            style={{
              padding: "2.5rem",
              borderRadius: "20px",
              background: "#ffffff",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1} mb={2}>
              <Typography variant="h5"          
               sx={{
                fontSize: { xs: "16px", md: "20px" }, // Adjust font size for subtitle
                fontWeight: "700",
                fontFamily: "'Hubballi', sans-serif",
                letterSpacing: "1px",
            }}> 
                CALCULATION RESULTS
              </Typography>
            </Stack>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems=""
        style={{ minHeight: "10vh" }}
      >


<Grid item xs={11} sm={11} md={12}>
              <Paper
                elevation={6}
                style={{
                  padding: "1rem",
                  borderRadius: "20px",
                  background: "#ffffff",
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
                }}
              >
  <Stack direction="row" alignItems="center" spacing={1} mb={2}>


     <Typography
     sx={{
        fontSize: { xs: "16px", md: "20px" },
        fontWeight: "700",
        fontFamily: "'Hubballi', sans-serif",
        letterSpacing: "1px",
      }}
>
  Active Cable Size  ({Active_cable_mode === "Automatic" ? "AS/NZS 3008:1:1: 2017 Section 2.2" : "User Selection"}): {number_of_active_circuits} X {Active_cable_size} mm² {inputData.cableType.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())}/{inputData.conductor}/{inputData.insulation.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())} Cable <br />
</Typography>
  </Stack>



  </Paper>
</Grid>


<Grid item xs={11} sm={11} md={4}>
              <Paper
                elevation={6}
                style={{
                  padding: "1rem",
                  borderRadius: "20px",
                  background: "#ffffff",
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
                }}
              >
  <Stack direction="row" alignItems="center" spacing={1} mb={2}>
    <Typography
      variant="h5"
      sx={{
        fontSize: { xs: "16px", md: "20px" },
        fontWeight: "700",
        fontFamily: "'Hubballi', sans-serif",
        letterSpacing: "1px",
      }}
    >
      CURRENT CARRYING CAPACITY{" "}
      <span
        style={{
          color: current_carrying_cap_ok ? "green" : "red",
          fontWeight: 700,
        }}
      >
        ({current_carrying_cap_ok ? "PASS" : "FAIL"})
      </span>
    </Typography>
  </Stack>


 <Typography
  sx={{
    fontSize: { xs: "1.1rem", md: "1.1rem" },
    fontWeight: "100",
    fontFamily: "'Hubballi', sans-serif",
    letterSpacing: "1px",
    lineHeight: 2,
  }}
>
  Current Carrying Capacity: {Circuit_capacity} A{" "}
  <Box
    component="span"
    sx={{
      backgroundColor: "#f5f5f5",
      padding: "2px 8px",
      borderRadius: "6px",
      display: "inline-flex",
      alignItems: "center",
      ml: 1,
    }}
  >
    <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1rem", mr: 0.5 }} />
    <Typography
      component="span"
      variant="body2"
      sx={{
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "0.85rem",
        color: "#333",
      }}
    >
      ref AS3008 — {current_carrying_cap_ref}
    </Typography>
  </Box>
  <br />

  Current Carrying Capacity (Derated): {Circuit_capacity_derated} A <br />
  Spare Capacity: {spare_capacity} A <br />
  Cable Operating Temperature: {operating_temp_calculation} °C

    <Box
    component="span"
    sx={{
      backgroundColor: "#f5f5f5",
      padding: "2px 8px",
      borderRadius: "6px",
      display: "inline-flex",
      alignItems: "center",
      ml: 1,
    }}
  >
    <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1rem", mr: 0.5 }} />
    <Typography
      component="span"
      variant="body2"
      sx={{
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "0.85rem",
        color: "#333",
      }}
    >
      Ref AS3008 Section 4.4
    </Typography>
  </Box>
</Typography>
  </Paper>
</Grid>


{derating && derating.length > 0 && (
  <Grid item xs={11} sm={11} md={4}>
    <Paper
      elevation={6}
      style={{
        padding: "1rem",
        borderRadius: "20px",
        background: "#ffffff",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <Typography
          variant="h5"
          sx={{
            fontSize: { xs: "16px", md: "20px" },
            fontWeight: "700",
            fontFamily: "'Hubballi', sans-serif",
            letterSpacing: "1px",
          }}
        >
          AS3008 1.1 Derating Conditions
        </Typography>
      </Stack>

      <Typography
        sx={{
          fontSize: { xs: "1.1rem", md: "1.1rem" },
          fontWeight: "100",
          fontFamily: "'Hubballi', sans-serif",
          letterSpacing: "1px",
          lineHeight: 2,
        }}
      >
        {derating.map(([label, [value, ref]], index) => (
          <div key={index}>
            {label}: {value}{" "}
            {ref && (
              <Box
                component="span"
                sx={{
                  backgroundColor: "#f5f5f5",
                  padding: "2px 8px",
                  borderRadius: "6px",
                  display: "inline-flex",
                  alignItems: "center",
                  ml: 1,
                }}
              >
                <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1rem", mr: 0.5 }} />
                <Typography
                  component="span"
                  variant="body2"
                  sx={{
                    fontFamily: "'Hubballi', sans-serif",
                    fontSize: "0.85rem",
                    color: "#333",
                  }}
                >
                  {ref}
                </Typography>
              </Box>
            )}
            <br />
          </div>
        ))}
      </Typography>
    </Paper>
  </Grid>
)}



<Grid item xs={11} sm={11} md={4}>
              <Paper
                elevation={6}
                style={{
                  padding: "1rem",
                  borderRadius: "20px",
                  background: "#ffffff",
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
                }}
              >
  <Stack direction="row" alignItems="center" spacing={1} mb={2}>
    <Typography
      variant="h5"
      sx={{
        fontSize: { xs: "16px", md: "20px" },
        fontWeight: "700",
        fontFamily: "'Hubballi', sans-serif",
        letterSpacing: "1px",
      }}
    >
      VOLTAGE DROP {" "}
      <span
        style={{
          color: current_carrying_cap_ok ? "green" : "red",
          fontWeight: 700,
        }}
      >
        ({voltage_drop_cap_ok ? "PASS" : "FAIL"})
      </span>
    </Typography>
  </Stack>


<Typography
  sx={{
    fontSize: { xs: "1.1rem", md: "1.1rem" },
    fontWeight: "100",
    fontFamily: "'Hubballi', sans-serif",
    letterSpacing: "1px",
    lineHeight: 2,
  }}
>
  Voltage Drop: {Voltage_drop} V    <Box
    component="span"
    sx={{
      backgroundColor: "#f5f5f5",
      padding: "2px 8px",
      borderRadius: "6px",
      display: "inline-flex",
      alignItems: "center",
      ml: 1,
    }}
  >
    <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1rem", mr: 0.5 }} />
    <Typography
      component="span"
      variant="body2"
      sx={{
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "0.85rem",
        color: "#333",
      }}
    >
      ref AS3008 Section 4.5
    </Typography>
  </Box><br /> 

  
  Percentage Voltage Drop: {voltage_drop_percent} % <br />
  Cable Resistance: {resistance_active} ohms/km{" "}
  <Box
    component="span"
    sx={{
      backgroundColor: "#f5f5f5",
      padding: "2px 8px",
      borderRadius: "6px",
      display: "inline-flex",
      alignItems: "center",
      ml: 1,
    }}
  >
    <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1rem", mr: 0.5 }} />
    <Typography
      component="span"
      variant="body2"
      sx={{
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "0.85rem",
        color: "#333",
      }}
    >
      ref AS3008:2017 — {resistance_active_ref}
    </Typography>
  </Box>
  <br />

  Cable Reactance: {reactance_active} ohms/km{" "}
  <Box
    component="span"
    sx={{
      backgroundColor: "#f5f5f5",
      padding: "2px 8px",
      borderRadius: "6px",
      display: "inline-flex",
      alignItems: "center",
      ml: 1,
    }}
  >
    <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1rem", mr: 0.5 }} />
    <Typography
      component="span"
      variant="body2"
      sx={{
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "0.85rem",
        color: "#333",
      }}
    >
      ref AS3008:2017 — {reactance_active_ref}
    </Typography>
  </Box>
  <br />

  Maximum Length of Cable: {max_length_cable} m <Box
    component="span"
    sx={{
      backgroundColor: "#f5f5f5",
      padding: "2px 8px",
      borderRadius: "6px",
      display: "inline-flex",
      alignItems: "center",
      ml: 1,
    }}
  >
    <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1rem", mr: 0.5 }} />
    <Typography
      component="span"
      variant="body2"
      sx={{
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "0.85rem",
        color: "#333",
      }}
    >
      ref AS3008 Section 4.5
    </Typography>
  </Box>
</Typography>
  </Paper>
</Grid>




<Grid item xs={11} sm={11} md={4}>
              <Paper
                elevation={6}
                style={{
                  padding: "1rem",
                  borderRadius: "20px",
                  background: "#ffffff",
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
                }}
              >
  <Stack direction="row" alignItems="center" spacing={1} mb={2}>
    <Typography
      variant="h5"
      sx={{
        fontSize: { xs: "16px", md: "20px" },
        fontWeight: "700",
        fontFamily: "'Hubballi', sans-serif",
        letterSpacing: "1px",
      }}
    >
      SHORT CIRCUIT TEMPERATURE RISE {" "}
      <span
        style={{
          color: short_circuit_cap_ok ? "green" : "red",
          fontWeight: 700,
        }}
      >
        ({short_circuit_cap_ok ? "PASS" : "FAIL"})
      </span>
    </Typography>
  </Stack>


<Typography
  sx={{
    fontSize: { xs: "1.1rem", md: "1.1rem" },
    fontWeight: "100",
    fontFamily: "'Hubballi', sans-serif",
    letterSpacing: "1px",
    lineHeight: 2,
  }}
>
  Fault Level At Source: {short_circuit_soure} A <br />
  Fault Level At Load: {short_circuit_load} A <br />
  Circuit Short Circuit Capacity: {short_circuit_capacity} A{" "}
  <Box
    component="span"
    sx={{
      backgroundColor: "#f5f5f5",
      padding: "2px 8px",
      borderRadius: "6px",
      display: "inline-flex",
      alignItems: "center",
      ml: 1,
    }}
  >
    <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1rem", mr: 0.5 }} />
    <Typography
      component="span"
      variant="body2"
      sx={{
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "0.85rem",
        color: "#333",
      }}
    >
      ref AS3008 Section 5.3
    </Typography>
  </Box>
  <br />

  K Value: {K_value}{" "}
  <Box
    component="span"
    sx={{
      backgroundColor: "#f5f5f5",
      padding: "2px 8px",
      borderRadius: "6px",
      display: "inline-flex",
      alignItems: "center",
      ml: 1,
    }}
  >
    <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1rem", mr: 0.5 }} />
    <Typography
      component="span"
      variant="body2"
      sx={{
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "0.85rem",
        color: "#333",
      }}
    >
      ref AS3008 — {K_value_ref}
    </Typography>
  </Box>
</Typography>
  </Paper>
</Grid>




<Grid item xs={11} sm={11} md={4}>
              <Paper
                elevation={6}
                style={{
                  padding: "1rem",
                  borderRadius: "20px",
                  background: "#ffffff",
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
                }}
              >
  <Stack direction="row" alignItems="center" spacing={1} mb={2}>
    <Typography
      variant="h5"
      sx={{
        fontSize: { xs: "16px", md: "20px" },
        fontWeight: "700",
        fontFamily: "'Hubballi', sans-serif",
        letterSpacing: "1px",
      }}
    >
      EARTH CABLE RECOMMENDATION {" "}
    </Typography>
  </Stack>


<Typography
  sx={{
    fontSize: { xs: "1.1rem", md: "1.1rem" },
    fontWeight: "100",
    fontFamily: "'Hubballi', sans-serif",
    letterSpacing: "1px",
    lineHeight: 2,
  }}
>
  Earth Cable Size: {number_of_earth_circuit} X {Earth_cable_size} mm² 

  <Box
    component="span"
    sx={{
      backgroundColor: "#f5f5f5",
      padding: "2px 8px",
      borderRadius: "6px",
      display: "inline-flex",
      alignItems: "center",
      ml: 1,
    }}
  >
    <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1rem", mr: 0.5 }} />
    <Typography
      component="span"
      variant="body2"
      sx={{
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "0.85rem",
        color: "#333",
      }}
    >
    {earthRef}
    </Typography>
  </Box>
  <br />

</Typography>

{earthCableSizingMode !== "Automatic" && (
  <>
    <Typography
      sx={{
        fontSize: { xs: "1.1rem", md: "1.1rem" },
        fontWeight: "600",
        fontFamily: "'Hubballi', sans-serif",
        letterSpacing: "1px",
        lineHeight: 2,
      }}
    >
      EARTH FAULT LOOP IMPEDANCE{" "}
      <span
        style={{
          color: EFLcheck ? "green" : "red",
          fontWeight: 700,
        }}
      >
        ({EFLcheck ? "PASS" : "FAIL"})
      </span>
      <br />
    </Typography>

{!inputData["rcdChecked"] ? (
  <Typography
    sx={{
      fontSize: { xs: "1.1rem", md: "1.1rem" },
      fontWeight: "100",
      fontFamily: "'Hubballi', sans-serif",
      letterSpacing: "1px",
      lineHeight: 2,
    }}
  >
    Z Internal: {Zint} ohms, Z External: {Zext} ohms <br />
    Fault Loop Impedance: {EFL} ohms <br />
    Maximum Fault Loop Impedance Allowed: {Requiredloopimpidance} ohms
    <br />
  </Typography>
) : (
  <Box
    component="span"
    sx={{
      backgroundColor: "#f5f5f5",
      padding: "12px 16px",
      borderRadius: "8px",
      display: "inline-flex",
      alignItems: "flex-start",
      gap: "8px",
      mt: 1,
    }}
  >
    <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1.2rem", mt: "2px" }} />
    <Typography
      component="span"
      variant="body2"
      sx={{
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "0.95rem",
        color: "#333",
      }}
    >
      Earth Fault Loop Impedance check for the earth cable is not considered, as it is assumed that the RCD installed will detect the earth fault and clear the fault within the required time. <br />
      
    </Typography>
  </Box>
)}

    <Typography
      sx={{
        fontSize: { xs: "1.1rem", md: "1.1rem" },
        fontWeight: "600",
        fontFamily: "'Hubballi', sans-serif",
        letterSpacing: "1px",
        lineHeight: 2,
      }}
    >
      SHORT CIRCUIT TEMPERATURE RISE{" "}
      <span
        style={{
          color: earthfaultlevelcheck ? "green" : "red",
          fontWeight: 700,
        }}
      >
        ({earthfaultlevelcheck ? "PASS" : "FAIL"})
      </span>
      <br />
    </Typography>

    <Typography
      sx={{
        fontSize: { xs: "1.1rem", md: "1.1rem" },
        fontWeight: "100",
        fontFamily: "'Hubballi', sans-serif",
        letterSpacing: "1px",
        lineHeight: 2,
      }}
    >
      L-G Fault Level: {earth_Fault_level} A, Earth Short Circuit Cap:{" "}
      {earthshortcircuitcap} A <br />
      K Value: {kvalue}
      <Box
        component="span"
        sx={{
          backgroundColor: "#f5f5f5",
          padding: "2px 8px",
          borderRadius: "6px",
          display: "inline-flex",
          alignItems: "center",
          ml: 1,
        }}
      >
        <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1rem", mr: 0.5 }} />
        <Typography
          component="span"
          variant="body2"
          sx={{
            fontFamily: "'Hubballi', sans-serif",
            fontSize: "0.85rem",
            color: "#333",
          }}
        >
          ref AS3008 {K_value_refearth}
        </Typography>
      </Box>
      <br />
    </Typography>
  </>
)}
  </Paper>
</Grid>


      </Grid>


          
          </Paper>
        </Grid>





      </Grid>


</div>
  );
}

export default ResultsComponent;
